// frontend/src/components/layout/ForcePasswordChange.tsx
import { useAuthStore } from '../../stores/authStore';
import { ChangePasswordModal } from './ChangePasswordModal';

/**
 * Pantalla que tapa todo cuando el usuario todavía tiene la contraseña que le dieron
 * (`must_change_password`). No se puede cerrar ni cancelar: o la cambia, o cierra la sesión.
 * Se monta en el Layout, así cubre cualquier pantalla del sistema.
 */
export function ForcePasswordChange() {
  const mustChange = useAuthStore((s) => s.user?.must_change_password ?? false);
  if (!mustChange) return null;
  return <ChangePasswordModal open forced onClose={() => {}} />;
}
